"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Brings id foward (swap with item at next index)
 * @param {Number} id
 * @param {Array} list
 * @return {Array} newList
 */
function bringForwards(id, list) {
  var newList = [].concat(_toConsumableArray(list));
  var indexOfId = newList.indexOf(id);
  if (indexOfId === 0 || indexOfId === -1) {
    return list; // nothing changed
  }

  var copy = list[indexOfId - 1];
  newList[indexOfId - 1] = id;
  newList[indexOfId] = copy;

  return newList;
}

exports.default = bringForwards;